import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const decisionWheelTool: Tool = {
  id: "decision-wheel",
  name: () => m.dw_tool_name(),
  description: () => m.dw_tool_description(),
  icon: "🎡",
  basePath: "/decision-wheel",
  status: "stable",
  tags: ["everyday", "random", "decision", "decision-wheel"],
};
